import {
    STORAGE_KEY_SOURCING_PDP_VISITS,
    pdpType,
} from './pdpSharedConsumerSourcingHelpersConstants';
import { localStorage } from 'dibs-browser-storage';

export const getUserPdpVisitsInfo = ({
    userId,
}: {
    userId: string;
}): { userPdpVisitsInfo: pdpType[]; userIndex: number } => {
    const userPdpVisitsInfo = (localStorage.getItem(STORAGE_KEY_SOURCING_PDP_VISITS) ||
        []) as pdpType[];
    const userIndex = userPdpVisitsInfo.findIndex(
        (pdpStore: pdpType) => pdpStore?.userId === userId
    );
    return { userPdpVisitsInfo, userIndex };
};
